module.exports = __webpack_public_path__ + "img/leste-logo.47c542dd.svg";